module.exports = __webpack_public_path__ + "img/phantom_assassin.5817d926.png";